/**
 * Telemetry Bootstrap — Wires telemetry into the app lifecycle.
 * Listens to auth state: init on sign-in, disable on sign-out.
 */

import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '@/firebase/config';
import { initTelemetry, disableTelemetry } from './telemetry';

export function bootstrapTelemetry() {
  onAuthStateChanged(auth, (user) => {
    if (user) {
      initTelemetry({ db, userId: user.uid });
    } else {
      disableTelemetry();
    }
  });
}
